<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col cols="12">
          <BaseCard
            title="LC Receive Entry"
            icon="mdi-truck-delivery"
            vCardTextClass="pa-2"
          >
            <v-row>
              <v-col md="3" cols="12">
                <v-card elevation="0" border rounded="lg" class="h-100">
                  <div class="d-flex align-center pa-2">
                    <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                      <v-icon size="20">mdi-information-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-subtitle-1 font-weight-medium">Main details</div>
                      <div class="text-caption text-medium-emphasis">Provide main information</div>

                    </div>
                  </div>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addPurOrder"
                  id="addPurOrder"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="import_gnr_master_id.value.value"
                        :items="getReceivableLcImportGnrListVar"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        @update:modelValue="onGnrChange"
                        :error-messages="import_gnr_master_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          GRN
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Warehouse
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        label="Supplier Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Supplier Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Receive Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="received_date.value.value"
                        :error-messages="received_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>





                      <v-text-field
                        label="Rfq By"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by.value.value"
                        :error-messages="purOrder_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Mobile"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by_mobile.value.value"
                        :error-messages="purOrder_by.errorMessage.value"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-text-field
                        label="Rfq By Email"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purOrder_by_email.value.value"
                        :error-messages="purOrder_by_email.errorMessage.value"
                        :disabled="true"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                </v-card>
              </v-col>
              <v-col class="pl-0" md="9" cols="12">
                <v-card elevation="0" border rounded="lg">
                  <div class="d-flex align-center pt-3 px-3">
                    <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                      <v-icon size="20">mdi-format-list-bulleted</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-subtitle-1 font-weight-medium">Receive items</div>
                      <div class="text-caption text-medium-emphasis">Review and manage imported receive items</div>
                    </div>
                  </div>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addPurOrder"
                  id="addPurOrder"
                >
                  <v-row class="pt-2 justify-center d-none">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.name}`"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                      <input
                        v-model="lc_receive_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                      <v-card elevation="0" class="overflow-x-auto">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="max-height: 600px ; overflow-y: scroll"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>
                            <th class="text-left" style="width: 15%">Code </th>
                            <th class="text-left" style="min-width:100px">Product Name</th>
                            <th class="text-center" style="width: 15%"> Lot No.</th>
                            <th class="text-center" style="width: 15%"> Expiry Date</th>
                            <th class="text-center" style="width: 15%"> Quantity</th>
                            <th class="text-center" style="width: 15%">Unit</th>
                            <th class="text-left" style="min-width:130px">Standard Purity (%)</th>
                            <th class="text-left" style="min-width:130px">Present Purity (%)</th>
                            <th class="text-center" style="width: 10%">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_code }}
                            </td>
                            <td
                              class="text-left py-1"
                              style="white-space: normal; min-width: 200px"
                            >
                              {{ item.product_name }}
                            </td>
                             <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                style="width: 100px"
                                type="text"
                                :hideInput="false"
                                :inset="false"
                                hide-details="true"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.lot_no"
                                @blur="item.lot_no"
                              ></v-text-field>
                            </td>
                            <td class="text-right pt-2">
                              <v-date-input
                                  input-format="dd/mm/yyyy"
                                  label="dd/mm/yyyy"
                                  density="compact"
                                  prepend-icon=""
                                  variant="outlined"
                                  hide-details="true"
                                  bg-color="grey-lighten-4"
                                  v-model="item.expiry_date"
                                  style="width: 130px"
                                  autocomplete="off"
                                  clearable
                              ></v-date-input>
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                label=""
                                style="width: 120px"
                                hide-details="true"
                                type="number"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>
                            <td
                                class="text-left py-1"
                                style="white-space: normal"
                            >
                              {{ item.standard_purity || 0 }}
                            </td>
                            <td class="text-right py-1">
                              <v-text-field
                                  style="width: 100px"
                                  density="compact"
                                  variant="outlined"
                                  bg-color="grey-lighten-4"
                                  hide-details="true"
                                  v-model="item.present_purity"
                                  @update:model-value="clampPurity(item)"
                              ></v-text-field>
                            </td>

                            <td class="text-center px-1">
                              <v-btn
                                  icon="mdi-delete-outline"
                                  size="small"
                                  color="error"
                                  variant="text"
                                  @click="removeFromCart(index)"
                              ></v-btn>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="11" class="text-center py-8">
                                <v-icon size="32" color="primary" class="mb-2">mdi-package-variant-closed</v-icon>
                                <div class="text-body-2 text-medium-emphasis">No items added yet</div>
                            </td>
                          </tr>
                        </tbody>
                        
                      </v-table>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
                </v-card>
              </v-col>
            </v-row>
            <v-divider class="mt-2"></v-divider>

            <v-card-actions>
              <v-row align="start">
                <v-col cols="12" md="8">
                  <v-textarea
                      label="Remarks"
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="remarks.value.value"
                      :error-messages="remarks.errorMessage.value"
                      autocomplete="off"
                      rows="3"
                      clearable
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex justify-end ga-2">
                    <v-btn color="grey-darken-1" variant="flat" prepend-icon="mdi-content-save-outline" @click="submitForm(0)">draft</v-btn>
                    <v-btn color="primary" variant="flat" prepend-icon="mdi-send-outline" @click="submitForm(1)">Post</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import BaseCard from "@/components/utils/baseCard.vue";
export default {
  components: {
    BaseCard,
  },
  data: () => ({
    panel: [0],
    panel2: [0],
    getReceivableLcImportGnrListVar: [],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
    types: [
      { id: 1, name: "Normal" },
      { id: 2, name: "Urgent" },
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
    // if (this.$store.getters.getSupplierList.length === 0) {
      this.$store.dispatch("getSupplierList");
    // }
    // if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    // }
    this.$store.dispatch("getReceivableLcImportGnrList").then(() => {
      const gnrList = this.$store.getters.getReceivableLcImportGnrList || [];
      this.getReceivableLcImportGnrListVar = gnrList.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    });
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      ); 
    },
    getSupplierList() {
      return this.$store.getters.getSupplierList;
    },
  },
  methods: {
    addCart() {
      //return;
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        lc_import_gnr_details_id: null,
        product_id: this.product_id.value.value,
        product_code: product.code,
        product_name: product.name,
        lot_no: null,
        expiry_date: null,
        qty: 1,
        standard_purity: product.standard_purity || 0,
        present_purity: product.standard_purity || 0,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        shipment_item_id:null,
      
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    clampPurity(item) {
      if (Number.isNaN(item.present_purity) || item.present_purity < 0) {
        item.present_purity = 0;
      } else if (item.present_purity > 100) {
        item.present_purity = 100;
      } else {
        item.present_purity = item.present_purity;
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    async onGnrChange(selectedId) {
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const response = await this.$store.dispatch(
          "getLcImportGnrById",
          selectedId
        );
        const data = response.data.data;

        this.warehouse_id.value.value =  data.warehouse_id || data.warehouse?.id || null;
        this.supplier_id.value.value =  data.supplier_id || data.supplier?.id || null;
        this.remarks.value.value = data.remarks || "";

        this.cart = [];
        (data.gnr_details || []).forEach((item) => {
          console.log(item)
          this.cart.push({
            lc_import_gnr_details_id: item.id,
            product_id: item.product_id,
            expiry_date: item.expiry_date,
            product_code: item.product?.code || "",
            product_name: item.product?.name || "",
            lot_no: item.lot_no,
            qty: item.received_qty,
            present_purity: item.present_purity ?? 0,
            unit_id: item.product?.unit_id || "",
            unit_name: item.product?.unit?.name || "",
            shipment_item_id: item.shipment_item_id ?? null,
          
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        //console.error("Failed to load requisition data:", error);
      }
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        received_date: yup.date().required().label("Receive Date"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
        import_gnr_master_id: yup.number().positive().integer().required().label("Requisition"),
        supplier_id: yup.number().positive().integer().required().label("Supplier Name"),
      }),
    });

    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const warehouse_id = useField("warehouse_id");
    const import_gnr_master_id = useField("import_gnr_master_id");
    const supplier_id = useField("supplier_id");
    const lc_receive_master_id = useField("lc_receive_master_id");
    const received_date = useField("received_date");

    const remarks = useField("remarks");
    const purOrder_by = useField("purOrder_by");
    const purOrder_by_mobile = useField("purOrder_by_mobile");
    const purOrder_by_email = useField("purOrder_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.received_date = formattedDate(received_date.value.value);

      values.cart = cart.value.map((item) => ({
        ...item,
        expiry_date:formattedDate(item.expiry_date)
      }));

      store
        .dispatch("saveUpdateInvLcReceive", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "lc-receive-records" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      product_id,
      received_date,
      remarks,
      cart,
      purOrder_by,
      purOrder_by_mobile,
      purOrder_by_email,
      pr_status,
      errorMessages,
      employee_id,
      warehouse_id,
      import_gnr_master_id,
      supplier_id,
      lc_receive_master_id,
      buttonText,
      loading,
    };
  },

  mounted() {
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.purOrder_by.value.value = user.full_name;
    this.purOrder_by_mobile.value.value = user.mobile;
    this.purOrder_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getInvLcReceiveById", id)
          .then((data) => {
            this.isEntryMode = false;
            let purOrder = data;

            this.getReceivableLcImportGnrListVar = [purOrder.grn];

            this.lc_receive_master_id.value.value = purOrder.id;
            this.received_date.value.value = purOrder.received_date
              ? new Date(purOrder.received_date)
              : new Date();
            this.warehouse_id.value.value = purOrder.warehouse.id;
            this.import_gnr_master_id.value.value = purOrder.import_gnr_master_id;
            this.product_id.value.value = null;
            this.supplier_id.value.value = purOrder.supplier.id;
            this.cart.value = [];

            // Insert items one by one
            (purOrder.details || []).forEach((item) => {
              this.cart.push({
                lc_import_gnr_details_id: item.lc_import_gnr_details_id,
                product_id: item.product_id,
                product_code: item.product?.code || "",
                product_name: item.product?.name || "",
                lot_no: item.lot_no,
                expiry_date: item.expiry_date || null,
                qty: item.qty,
                standard_purity: item.product?.standard_purity || 0,
                present_purity: item.present_purity|| 0,
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                rate: item.rate,
                total: item.qty * item.rate,
                sale_price: item.sale_price,
                shipment_item_id: item.shipment_item_id ?? null,
              });
            });
            this.remarks.value.value = purOrder.remarks ? purOrder.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            //console.error("Failed to fetch rfq:", error);
          });
      });
    } else {
      this.lc_receive_master_id.value.value = "";
      this.received_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
